<template>
  <div class="box">
    <Title
      :text="electricity.energyConsumptionDistribution.Title[0]"
      :engText="electricity.energyConsumptionDistribution.Title[1]"
    ></Title>
    <div class="content">
        <div class="echarts-content">
            <chart-block ref="echart"></chart-block>
        </div>
    </div>
  </div>

</template>
<script>
import Title from '../../components/title/index.vue';
import { mapState,mapActions } from 'pinia' //引入映射函数
 import useStore from '@/store/index' //引入store
export default {
    components: {
      Title,
    },
    computed:{
      ...mapState(useStore,['electricity']) 
    },
    mounted () {
      this.$refs.echart.setOption(this.electricity.energyConsumptionDistribution.Option);
    }
}
</script>
<style scoped>
    .box{
       width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .content{
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      /* background-color: red; */
    }
</style>